
//find all elements that have the "collapsed" data attribute
const collapsingContainers = document.querySelectorAll('[data-collapsed]');

//add an toggle, open and close event listener to them, so we can wait for them to be triggered later
for (const collapsingContainer of collapsingContainers) {

    //depending on the current state of the container, open or close it
    collapsingContainer.addEventListener('toggle', (event) => {
        if (collapsingContainer.getAttribute('data-collapsed') === 'true') {
            collapsingContainer.dispatchEvent(new Event('open'));
        } else {
            collapsingContainer.dispatchEvent(new Event('close'));
        }
    });

    //open the container if it is not already open
    collapsingContainer.addEventListener('open', (event) => {

        //only start the transition if the container is already collapsed
        if (collapsingContainer.getAttribute('data-collapsed') === 'true') {

            //get the height of the container's inner content, regardless of its actual size
            const containerHeight = collapsingContainer.scrollHeight;

            //have the container transition to the height of its inner content
            collapsingContainer.style.height = containerHeight + 'px';

            //when the next css transition finishes (which should be the one we just triggered)
            collapsingContainer.addEventListener('transitionend', function(e) {

                //remove this event listener so it only gets triggered once
                collapsingContainer.removeEventListener('transitionend', arguments.callee);

                //remove "height" from the container's inline styles, so it can return to its initial value
                collapsingContainer.style.height = null;

            });

            //mark the container as "currently not collapsed"
            collapsingContainer.setAttribute('data-collapsed', 'false');

        }
    });

    //close the container if it is not already close
    collapsingContainer.addEventListener('close', (event) => {

        //only start the transition if the container is not already collapsed
        if (collapsingContainer.getAttribute('data-collapsed') !== 'true') {

            //get the height of the container's inner content, regardless of its actual size
            const containerHeight = collapsingContainer.scrollHeight;

            //temporarily disable all css transitions
            const collapsingContainerTransition = collapsingContainer.style.transition;
            collapsingContainer.style.transition = '';

            //on the next frame (as soon as the previous style change has taken effect), explicitly set the container's height to its current pixel height, so we aren't transitioning out of 'auto'
            requestAnimationFrame(function() {

                //
                collapsingContainer.style.height = containerHeight + 'px';
                collapsingContainer.style.transition = collapsingContainerTransition;

                //on the next frame (as soon as the previous style change has taken effect), set the container's height back to 0
                requestAnimationFrame(function() {
                    collapsingContainer.style.height = 0 + 'px';
                });

            });

            //mark the container as "currently collapsed"
            collapsingContainer.setAttribute('data-collapsed', 'true');

        }

    });

}
